export function isNetworkError(error) {
  if (!error || error.response) {
    return false
  }
  const message = String(error.message || '')
  return error.code === 'ECONNABORTED' ||
    error.code === 'ERR_NETWORK' ||
    message.includes('Network Error') ||
    message.includes('timeout') ||
    !!error.request
}
